const ACCESS = "oraclemark_access_token";
const REFRESH = "oraclemark_refresh_token";

export function getAccessToken() {
  if (typeof window === "undefined") return null;
  return window.localStorage.getItem(ACCESS);
}

export function getRefreshToken() {
  if (typeof window === "undefined") return null;
  return window.localStorage.getItem(REFRESH);
}

export function setTokens(accessToken, refreshToken) {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(ACCESS, accessToken);
  window.localStorage.setItem(REFRESH, refreshToken);
}

export function setAccessToken(accessToken) {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(ACCESS, accessToken);
}

export function clearTokens() {
  if (typeof window === "undefined") return;
  window.localStorage.removeItem(ACCESS);
  window.localStorage.removeItem(REFRESH);
}
